import clsx from 'clsx';
import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { useTabsContext } from './Tabs';

type Props = {
  children: ReactNode;
  className?: string;
  value: number;
  contextId?: string;
};

const TabsTrigger = ({ children, className, value, contextId = 'default' }: Props) => {
  const { activeTab, setActiveTab } = useTabsContext(contextId);

  return (
    <button
      onClick={() => setActiveTab(value)}
      className={twMerge(
        clsx(
          'flex-basis-0 flex-shrink flex-grow rounded-full p-13 text-lg font-medium text-grey-300 transition-colors duration-500',
          activeTab === value && 'active-tab z-2 text-white',
          className,
        ),
      )}
    >
      {children}
    </button>
  );
};

export default TabsTrigger;
